<template>
    <button 
        type="button"
        class="btn btn-sm d-flex align-items-center time-clock-btn"
        :class="isClockedIn ? 'btn-outline-success' : 'btn-outline-secondary'"
        @click="$emit('open-modal')"
        :title="statusText"
    >
        <i class="fas fa-clock me-2"></i>
        <span class="d-none d-md-inline">{{ statusText }}</span>
        <span v-if="isClockedIn && formattedElapsedTime" class="ms-2 badge bg-success-subtle text-success d-none d-lg-inline">
            {{ formattedElapsedTime }}
        </span>
    </button>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue';
import { useTimeClock } from '@/composables/useTimeClock';

defineEmits(['open-modal']);

const {
    isClockedIn,
    statusText,
    formattedElapsedTime,
    fetchStatus
} = useTimeClock();

const REFRESH_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes
let refreshInterval: number | null = null;

onMounted(async () => {
    // Fetch initial status
    await fetchStatus();
    
    // Set up periodic refresh every 5 minutes
    refreshInterval = window.setInterval(async () => {
        await fetchStatus();
    }, REFRESH_INTERVAL_MS);
});

onUnmounted(() => {
    // Clean up interval on component unmount
    if (refreshInterval) {
        clearInterval(refreshInterval);
        refreshInterval = null;
    }
});
</script>

<style scoped>
.time-clock-btn {
    border-width: 1px;
    white-space: nowrap;
}

.time-clock-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.time-clock-btn:hover * {
    color: #fff!important;
}

.bg-success-subtle {
    background-color: rgba(25, 135, 84, 0.15) !important;
}
</style>
